import { z } from 'zod';

export const OrderSearchFormSchema = z.object({
    orderNumber: z.string().refine(value => /^\d+$/.test(value) && value.length >= 8 && value.length <= 10, {
        message: 'Please enter a valid order number',
    }),
    email: z
        .string()
        .min(1, {
            message: 'Please enter an email address',
        })
        .email({ message: 'Please enter a valid email address' }),
});
